import {styled} from "styled-components";

export const SignatureImage = styled.img`
  max-width: 6rem;
  max-height: 6rem;
`;
